import React from 'react';

// CRITICAL: EMPTY_STATE_TIPS must be module-scope const — NOT inside the component (Hot #102)
const EMPTY_STATE_TIPS = [
  'Try a partial symbol name — "User" instead of "UserService"',
  'Check the spelling of the symbol name',
  'Use a shorter query to find more matches',
  'Search in a different branch — symbols may not be on main',
] as const;

interface EmptyStateProps {
  query: string;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}

export default function EmptyState({
  query,
  hasActiveFilters,
  onClearFilters,
}: EmptyStateProps): React.ReactElement {
  const tip = EMPTY_STATE_TIPS[query.length % EMPTY_STATE_TIPS.length];

  return (
    <div className="empty-state" data-testid="empty-state">
      <div className="empty-state-title">
        No results for &ldquo;{query}&rdquo;
      </div>
      <div
        className="empty-state-tip"
        data-testid="empty-state-tip"
      >
        <span data-testid="no-results-tip">{tip}</span>
      </div>
      {hasActiveFilters && (
        <div
          className="empty-state-tip"
          data-testid="empty-state-filter-tip"
        >
          <span data-testid="no-results-filter-tip">
            Try removing active filters to search all repositories
          </span>
        </div>
      )}
      <div className="empty-state-actions">
        {hasActiveFilters && (
          <button
            type="button"
            className="empty-state-btn"
            onClick={onClearFilters}
          >
            Clear filters
          </button>
        )}
      </div>
    </div>
  );
}
